import type { GovernmentReportingServiceType } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const createItemJurisdictionCodeMutationAtom = createMutationAtomFactory(
  'settings.itemJurisdictionCodeCreate',
  (params: {
    itemId: string;
    serviceType: GovernmentReportingServiceType;
    code: string;
    isReportable: boolean;
  }) => ({
    complianceComplianceItemJurisdictionCodeCreate: {
      __args: {
        input: {
          itemId: params.itemId,
          serviceType: params.serviceType,
          code: params.code,
          isReportable: params.isReportable,
        },
      },
      id: true,
    },
  }),
);
